module.exports = __webpack_public_path__ + "res/4-img_top_center_rtl.ebe6b10db18731a780b3063f1dd8dc89.png";